import React, { useCallback, useEffect, useRef, useState } from "react";
import "./Orders.css";
import DataTable from "react-data-table-component";
import { PopupModal } from "../Components";
import AlertDeletePopupModal from "../Components/PopupModal/AlertDeletePopupModal";
import axiosConfig from "../Service/axiosConfig";
import { BiRupee } from "react-icons/bi";
import Select from "react-select";
import { TbSearch } from "react-icons/tb";
import {
  MdOutlineLocationOn,
  MdPrint,
  MdOutlineEditNote,
  MdOutlineLocalPhone,
  MdOutlineMapsHomeWork,
} from "react-icons/md";
import { RiSendPlaneFill } from "react-icons/ri";
import { GrGallery } from "react-icons/gr";
import { IoCloseCircleOutline } from "react-icons/io5";
import tableCustomStyles from "../Components/PopupModal/tableCustomStyles";
import { useReloadContext } from "../Components/DashboardLayout/DashboardLayout";
import useDebouncedValue from "../Utils/Debounce";
import { useNavigate } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { ShippingInstructions } from "./ShippingInstructions";
import { SiGooglemaps } from "react-icons/si";
import { IoMdCopy } from "react-icons/io";
const Orders = () => {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user_data"));
  const [stores, setStores] = useState([]);
  const [OrderDetail, SetOrderDetails] = useState([]);
  const [search, setSearch] = useState("");
  const debouncedSearchTerm = useDebouncedValue(search, 500);
  const [popupType, setpopupType] = useState("");
  const [OrderId, SetOrderId] = useState();
  const [oreders, setOrders] = useState({});
  const [OrderBiId, SetOrderById] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [orderInfo, setOrderInfo] = useState({});
  const [Active, setActive] = useState("Placed");
  const [Invoice, setInvoice] = useState({});
  const [loadingButton, setLoadingButton] = useState(false);
  const { reload = false, setReload = () => {}, formatDate = () => {} } = useReloadContext() || {};
  const [DataCount, setDataCount] = useState("");
  const [AlertDeletePopupType, SetAlertDeletePopupType] = useState("");
  const [RowId, SetRowId] = useState();
  const [AlertDeletePopupType1, SetAlertDeletePopupType1] = useState("");
  const [RowId1, SetRowId1] = useState();
  const [message, setMessage] = useState(null);
  const [discountTotals, setDiscountTotals] = useState(null);
  const [newOrdersCount, setNewOrdersCount] = useState(0);
  const [page, setPage] = useState(1);
  const [TotalPages, setTotalPages] = useState(0);
  const [preserveActiveTab, setPreserveActiveTab] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [selectedOrderForAddress, setSelectedOrderForAddress] = useState(null);
  const [lastOrderId, setLastOrderId] = useState(null);
  const [hasNewOrders, setHasNewOrders] = useState(false);
  const prevActiveRef = useRef(Active);
  const pollingIntervalRef = useRef(null);

  const currentDate = new Date();
  const year = currentDate.getFullYear();
  const month = currentDate.getMonth() + 1;
  const day = currentDate.getDate();
  const formattedDate = `${year}-${month.toString().padStart(2, "0")}-${day
    .toString()
    .padStart(2, "0")}`;
  const lastSevenDays = new Date(currentDate);
  lastSevenDays.setDate(currentDate.getDate() - 7);

  const formatedDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const startDate = formatedDate(lastSevenDays);  // 7 days ago
  const endDate = formatedDate(currentDate);      // today
  let store_id = JSON.parse(localStorage.getItem("Store"))?.id;
  const prevStoreRef = useRef(store_id);
  const [selectedStore, setSelectedStore] = useState({ value: store_id || "" });
  const [show, setShow] = useState(false);

  // Get counts for TODAY'S orders only
  const CountDisplay = useCallback(async () => {
    try {
      const response = await axiosConfig.get(
        `accounts/today_order_count/?store=${selectedStore?.value}&start_date=${startDate}&end_date=${endDate}`
      );

      setDataCount({
        ...DataCount,
        Cart: response.data.Cart || 0,
        Rejected: response.data.Rejected || 0,
        Delivered: response.data.Delivered || 0,
        Placed: response.data.Placed || 0,
        Accepted: response.data.Accepted || 0,
        "Ready to Ship": response.data["Ready to Ship"] || 0,
        Shipped: response.data.Shipped || 0,
      });
    } catch (error) {
      console.log("CountDisplay error:", error);
    }
  }, [selectedStore?.value, formattedDate]);

  function calculateDiscountTotals(couponApplied) {
    return couponApplied.reduce(
      (totals, item) => {
        if (item.discount_type === "BogoDiscount") {
          totals.bogo_discount += parseFloat(item.coupon_discount);
        } else if (item.discount_type === "DiscountCoupon") {
          totals.product_discount += parseFloat(item.coupon_discount);
        }
        return totals;
      },
      { bogo_discount: 0, product_discount: 0 }
    );
  }

  const GetStores = useCallback(async () => {
    if (stores.length > 0) return;
    try {
      const responce = await axiosConfig.get(`/stores/stores/?page_size=1000`);
      setStores(responce.data.results);
    } catch (error) {
      console.log("GetStores error:", error);
    }
  }, [stores.length]);

  const handleStoreChange = (selectedOption) => {
    setSelectedStore({ value: selectedOption?.value || "" });
  };

  // Get today's orders for the selected status
  const OrderDetails = useCallback(async (status, checkForNewOnly = false) => {
    setLoading(true);
    try {
      const response = await axiosConfig.get(
        `/accounts/orders/?user=&orderstatus=${status}&order_date_after=${startDate}&order_date_before=${endDate}&stores=${selectedStore.value}`
      );

      // Check if we have new orders
      if (checkForNewOnly && response.data.results.length > 0) {
        const latestOrderId = response.data.results[0].id;
        if (latestOrderId !== lastOrderId) {
          setHasNewOrders(true);
          setLastOrderId(latestOrderId);
          return true; // Indicates new orders are available
        }
        return false; // No new orders
      }

      setDataCount((prev) => ({
        ...prev,
        [status]: response.data.count,
      }));

      if (response.data.results.length > 0) {
        HandleOrder(
          response.data.results[0].id,
          0,
          response.data.results[0].total_quantity,
          response.data.results[0].orderstatus,
          response.data.results[0].delivery_charges,
          response.data.results[0].packing_charges,
          response.data.results[0].discount_amount,
          response.data.results[0].total_amount,
          response.data.results[0].net_amount,
          response.data.results[0].user_name,
          response.data.results[0].addresses,
          response.data.results[0].delivery_type,
          response.data.results[0].store,
          response.data.results[0].invoice,
          response.data.results[0].payment_mode,
          response.data.results[0]
        );
        setOrderInfo(response.data.results[0]);
      } else {
        SetOrderById([]);
        setOrders({});
      }

      SetOrderDetails(response.data.results);
      setTotalPages(Math.ceil(response.data.count / 10));
    } catch (error) {
      console.log("OrderDetails error:", error);
    } finally {
      setLoading(false);
    }
  }, [selectedStore.value, formattedDate, lastOrderId]);


  const setupPolling = useCallback(() => {
    if (pollingIntervalRef.current) {
      clearInterval(pollingIntervalRef.current);
    }

    // if (Active === "Placed" || Active === "Accepted") {
    //   pollingIntervalRef.current = setInterval(async () => {
    //     const hasNew = await OrderDetails(Active, true);
    //     if (hasNew) {
    //       CountDisplay();
    //     }
    //   }, 30000);
    // }
  }, [Active, OrderDetails, CountDisplay]);

  // Get today's order status totals
  const OrderStatusTotal = useCallback(async () => {
    setLoading(true);
    try {
      const confirmedResponse = await axiosConfig.get(
        `/accounts/orders/?user=&orderstatus=Placed&order_date_after=${startDate}&order_date_before=${endDate}&stores=${selectedStore?.value}`
      );

      setNewOrdersCount(confirmedResponse.data.count);

      const acceptedResponse = await axiosConfig.get(
        `/accounts/orders/?user=&orderstatus=Accepted&order_date_after=${startDate}&order_date_before=${endDate}&stores=${selectedStore?.value}`
      );
      const readyToShipResponse = await axiosConfig.get(
        `/accounts/orders/?user=&orderstatus=Ready to Ship&order_date_after=${startDate}&order_date_before=${endDate}&stores=${selectedStore?.value}`
      );
      const shippedResponse = await axiosConfig.get(
        `/accounts/orders/?user=&orderstatus=Shipped&order_date_after=${startDate}&order_date_before=${endDate}&stores=${selectedStore?.value}`
      );

      if (confirmedResponse.data.results.length > 0) {
        const firstOrder = confirmedResponse.data.results[0];
        HandleOrder(
          firstOrder.id,
          0,
          firstOrder.total_quantity,
          firstOrder.orderstatus,
          firstOrder.delivery_charges,
          firstOrder.packing_charges,
          firstOrder.discount_amount,
          firstOrder.total_amount,
          firstOrder.net_amount,
          firstOrder.user_name,
          firstOrder.addresses,
          firstOrder.delivery_type,
          firstOrder.store,
          firstOrder.invoice,
          firstOrder.payment_mode,
          firstOrder
        );
        setOrderInfo(confirmedResponse.data.results[0]);
        setTotalPages(Math.ceil(confirmedResponse.data.count / 10));
      }

      SetOrderDetails(confirmedResponse.data.results);
      setTotalPages(Math.ceil(confirmedResponse.data.count / 10));
      setDataCount((prev) => ({
        ...prev,
        Placed: confirmedResponse.data.count,
        Accepted: acceptedResponse.data.count,
        "Ready to Ship": readyToShipResponse.data.count,
        Shipped: shippedResponse.data.count,
      }));

      setReload(false);
    } catch (error) {
      console.error("OrderStatusTotal error:", error);
    } finally {
      setLoading(false);
    }
  }, [selectedStore?.value, setReload, formattedDate]);

  const checkForNewOrders = async () => {
    try {
      const response = await axiosConfig.get(
        `/accounts/orders/?user=&orderstatus=Placed&order_date_after=${startDate}&order_date_before=${endDate}&stores=${selectedStore?.value}`
      );

      // Just update the count without switching tabs
      if (response.data.count !== newOrdersCount) {
        setDataCount(prev => ({
          ...prev,
          Placed: response.data.count
        }));
        setNewOrdersCount(response.data.count);
      }
    } catch (error) {
      console.error("Error checking for new orders:", error);
    }
  };

  const handleInfiniteScroll = async (e) => {
    try {
      const { scrollTop, clientHeight, scrollHeight } = e.target;
      if (scrollTop + clientHeight >= scrollHeight - 50) {
        if (page < TotalPages) {
          setLoading2(true);
          setPage(page + 1);
          let resp = await axiosConfig.get(
            `/accounts/orders/?user=&orderstatus=Placed&page=${page + 1
            }&order_date_after=${startDate}&order_date_before=${endDate}&stores=${selectedStore?.value
            }`
          );
          SetOrderDetails((Data) => [...Data, ...resp.data.results]);
          setDataCount((prev) => ({
            ...prev,
            Placed: resp.data.count,
          }));
          setLoading2(false);
        } else {
          setLoading2(false);
        }
      }
    } catch (error) {
      console.log(error);
      setLoading2(false);
    }
  };

  const timeConvert = (date) => {
    const givenDateTime = new Date(date);
    let hours = givenDateTime.getHours();
    const minutes = givenDateTime.getMinutes();
    const ampm = hours >= 12 ? "PM" : "AM";
    hours %= 12;
    hours = hours || 12;
    const newTime = `${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")} ${ampm}`;
    return newTime;
  };

  const HandleSearch = (e) => {
    const { name, value } = e.target;
    setSearch(value);
  };

  const columns = [
    {
      name: "Item",
      selector: "",
      reorder: true,
      cell: (row) => (
        <>
          <div className="itm-table">
            <div className="table-image-main">
              <img
                src={row.product.image && row.product.image.image}
                alt={row.product.name}
                className="table-itm-img"
              />
            </div>
            <div className="image-name-order">
              <div>{row.product.name}</div>
              <div>
                {row.product.weight_in_kg
                  ? row.product.weight_in_kg
                  : `${row.product.weight || ""} ${row.product.measurement_unit || ""}`.trim()}
              </div>
              <div className="discount-comment">{row.discount_comment}</div>
            </div>
          </div>
        </>
      ),
    },
    {
      name: "Qty",
      reorder: true,
      selector: "quantity",
      cell: (row) => row.quantity,
    },
    {
      name: "Price",
      selector: "price",
      reorder: true,
      cell: (row) => {
        if (row.product && row.price) {
          const offerPrice = parseFloat(row.product.offer_price);
          return offerPrice > 0 ? (
            <div>
              <strike>{row.product.price}</strike> {offerPrice.toFixed(2)}
            </div>
          ) : (
            row.product.price
          );
        } else {
          return "N/A";
        }
      },
    },
    {
      name: "Amount",
      reorder: true,
      selector: "price",
      cell: (row) =>
        row.total_amount
          ? parseFloat(row.total_amount).toFixed(2)
          : parseFloat((row.price * row.quantity).toFixed(2)),
    },
  ];

  const HandleOrder = useCallback(async (
    id,
    i,
    qty,
    status,
    delivery_charges,
    packing_charges,
    discount_amount,
    total_amount,
    net_amount,
    user_name,
    addresses,
    delivery_type,
    store,
    invoice,
    payment_mode,
    order
  ) => {
    // Only call order details API if we're changing to a different order
    if (oreders.order_id !== id || hasNewOrders) {
      setLoading(true);
      try {
        const responce1 = await axiosConfig.get(
          `/accounts/neworder-detail/?order=${id}&page_size=1000`
        );
        SetOrderById(responce1.data.results);
        setHasNewOrders(false); // Reset flag after processing new order
      } catch (error) {
        console.log("HandleOrder error:", error);
      }
    }

    // Update the UI state regardless
    SetOrderId(i);
    setOrderInfo(order);
    setOrders({
      order_id: id,
      total_items: qty,
      status: status,
      delivery_charges: delivery_charges,
      packing_charges: packing_charges,
      discount_amount: discount_amount,
      total_amount: total_amount,
      net_amount: net_amount,
      user_name: user_name,
      addresses: addresses,
      delivery_type: delivery_type,
      store: store,
      invoice: invoice,
      payment_mode: payment_mode,
      delivery_charges_offer: order.delivery_charges_offer
        ? order.delivery_charges_offer
        : 0,
      packing_charges_offer: order.packing_charges_offer
        ? order.packing_charges_offer
        : 0,
      delivery_agent: order.delivery_agent ? order.delivery_agent : "",
      order: order,
    });
    setInvoice(invoice);
    let totals = calculateDiscountTotals(order?.coupon_code);
    setDiscountTotals(totals);
    setLoading(false);
  }, [oreders.order_id, hasNewOrders]);
  const handlePrint = async (id) => {
    try {
      const res = await axiosConfig.get(`accounts/pdf/${id}/`, {
        responseType: "blob"
      })
      const file = new Blob([res.data], { type: "application/pdf" })
      const fileUrl = URL.createObjectURL(file)
      window.open(fileUrl, "_blank", "noopener,noreferrer")
    } catch (error) {
      console.log(error);
      alert("Pdf not available")
    }
  };

  const HandleDelete = async () => {
    let resp = await axiosConfig.post(
      `/accounts/orders/${RowId}/order_status_update/`,
      { orderstatus: "Rejected" }
    );
    setMessage("Order Cancelled Successfully !");
    setpopupType("success");
    setLoadingButton(false);
    SetAlertDeletePopupType("error");
    CountDisplay();
    OderSCount(["Rejected", Active]);
  };

  const CancelAlerrt = () => {
    setLoadingButton(false);
    setMessage(null);
    SetAlertDeletePopupType("error");
  };

  const CancelAlerrt1 = () => {
    setLoadingButton(false);
    setMessage(null);
    SetAlertDeletePopupType1("error");
  };

  const HandleAccept = async () => {
    let resp = await axiosConfig.post(
      `/accounts/orders/${RowId1}/order_status_update/`,
      { orderstatus: "Accepted" }
    );
    setMessage("Order Accepted Successfully!");
    setpopupType("success");
    setActive("Accepted");
    SetAlertDeletePopupType1("error");
    OderSCount(["Accepted", "Placed"]);
    OrderDetails("Accepted");
    CountDisplay();
    setLoadingButton(false);
  };

  const Handlestatus = useCallback((status) => {
    setPreserveActiveTab(true);
    setActive(status);
    OrderDetails(status);
  }, [OrderDetails]);

  const OderSCount = async (statuses) => {
    setLoading(true);
    try {
      const responses = await Promise.all(
        statuses.map((status) => {
          return axiosConfig.get(
            `/accounts/orders/?user=&orderstatus=${status}&order_date_after=${startDate}&order_date_before=${endDate}&stores=${selectedStore?.value}`
          );
        })
      );

      // Update all counts at once
      const updatedCounts = {};
      statuses.forEach((status, index) => {
        updatedCounts[status] = responses[index].data.count;
      });

      setDataCount(prev => ({
        ...prev,
        ...updatedCounts
      }));

      // Refresh current active tab if needed
      if (statuses.includes(Active)) {
        const currentStatusIndex = statuses.indexOf(Active);
        SetOrderDetails(responses[currentStatusIndex].data.results);
      }
    } catch (error) {
      console.error("Error fetching order counts:", error);
    } finally {
      setLoading(false);
    }
  };

  const Handlebutttons = useCallback(async (status) => {
    setLoadingButton(true);
    try {
      let nextStatus = "";
      let currentStatus = Active;

      if (status === "Done") {
        setShow(true);
        SetRowId1(oreders.order_id);
        setLoadingButton(false);
        return;
      } else if (status === "Ready to Ship") {
        nextStatus = "Ready to Ship";
        currentStatus = "Accepted";
      } else if (status === "Shipped") {
        nextStatus = "Shipped";
        currentStatus = "Ready to Ship";
      } else if (status === "Delivered") {
        nextStatus = "Delivered";
        currentStatus = "Shipped";
      } else if (status === "Reject") {
        SetRowId(oreders.order_id);
        setMessage("Are you sure you want to cancel this order?");
        SetAlertDeletePopupType("success");
        setLoadingButton(false);
        return;
      } else if (status === "Modify") {
        navigate(`/dashboard/orders/${oreders.order_id}/modify`, {
          state: { order_data: orderInfo, order_address: oreders },
        });
        setLoadingButton(false);
        return;
      }

      // Update the order status
      let resp = await axiosConfig.post(
        `/accounts/orders/${oreders.order_id}/order_status_update/`,
        { orderstatus: nextStatus }
      );

      // Update the UI state
      setActive(nextStatus);

      // Refresh the order lists for both current and next status
      await OderSCount([nextStatus, currentStatus]);
      await CountDisplay();

      // If we have order details, update the current order's status
      if (oreders.order_id) {
        setOrders(prev => ({
          ...prev,
          status: nextStatus
        }));
      }
    } catch (error) {
      console.error("Handlebutttons error:", error);
    } finally {
      setLoadingButton(false);
    }
  }, [Active, oreders, orderInfo, navigate, OderSCount, CountDisplay]);

  const HandleButtons = () => {
    // Use address & customer info from order-detail API response
    const deliveryAddress = OrderBiId[0]?.delivery_address;
    const customerDetails = OrderBiId[0]?.customer_details;
    const customerName = customerDetails?.full_name || deliveryAddress?.name || oreders.addresses?.name;
    const customerPhone = customerDetails?.mobileno || deliveryAddress?.user?.mobileno || oreders.addresses?.user?.mobileno;
    const customerAddress = deliveryAddress?.address || oreders.addresses?.address;

    return (
      <div className="rowAligned gap-20 flex-1">
        <div className="flex-1 column-h-71">
          <div className="rowBetweenCenter">
            <div className="rowAligned gap-10">
              <MdOutlineMapsHomeWork size={16} />
              <div className="client-address f_13_600">
                {customerName}
              </div>
            </div>
            <div className="icon-container-16">
              <a
                href={`tel:+${customerPhone}`}
                style={{ height: "28px" }}
              >
                <MdOutlineLocalPhone size={14} color="#1b7d78" />
              </a>
            </div>
          </div>
          <div className="rowBetweenCenter">
            <div className="rowAligned gap-10">
              <MdOutlineLocationOn size={16} />
              <div className="client-address f_13_500">
                {customerAddress}.
              </div>
            </div>
            <div className="icon-container-16">
              <RiSendPlaneFill size={14} color="#1b7d78" onClick={() => showAddress()} />
            </div>
          </div>
          <div className="rowBetweenCenter">
            <div className="f_13_400 rowAligned gap-10">
              <MdOutlineLocalPhone size={16} color="#8C8C8C" />
              <div style={{ color: "#8C8C8C" }}>
                {customerPhone}
              </div>
            </div>
          </div>
          <div className="rowBetweenCenter">
            <div className="payment-modee">
              {oreders.payment_mode === "cash"
                ? "Cash on delivery"
                : "Online payment"}
            </div>
            <div className="order-statuss">{oreders.status}</div>
          </div>
        </div>
      </div>
    );
  };

  useEffect(() => {
    const getSearchResults = async () => {
      try {
        let resp = await axiosConfig.get(
          `/accounts/orders/?user=&orderstatus=${Active}&order_date_after=${startDate}&order_date_before=${endDate}&order_no=${debouncedSearchTerm}&stores=${selectedStore?.value}`
        );
        SetOrderDetails(resp.data.results);
        setDataCount((prev) => ({
          ...prev,
          [Active]: resp.data.count,
        }));
      } catch (error) {
        console.log(error);
      }
    };

    getSearchResults();
  }, [debouncedSearchTerm]);

  useEffect(() => {
    const fetchData = async () => {
      // If we should preserve the active tab, only refresh counts
      if (preserveActiveTab && reload) {
        CountDisplay();
        GetStores();
        setPreserveActiveTab(false);
        return;
      }

      // Check for new orders but don't switch tabs
      if (reload) {
        checkForNewOrdersAndSwitch();
        OrderDetails(Active);
      }

      CountDisplay();
      GetStores();
    };

    fetchData();
  }, [reload, Active, preserveActiveTab, CountDisplay, GetStores, OrderDetails]);

  useEffect(() => {
    setupPolling();

    // Cleanup on unmount
    return () => {
      if (pollingIntervalRef.current) {
        clearInterval(pollingIntervalRef.current);
      }
    };
  }, [setupPolling]);

  useEffect(() => {
    if (prevActiveRef.current !== Active || prevStoreRef.current !== selectedStore.value) {
      OrderDetails(Active);
      prevActiveRef.current = Active;
      prevStoreRef.current = selectedStore.value;
    }
  }, [Active, selectedStore.value, OrderDetails]);

  const checkForNewOrdersAndSwitch = async () => {
    try {
      const response = await axiosConfig.get(
        `/accounts/orders/?user=&orderstatus=Placed&order_date_after=${startDate}&order_date_before=${endDate}&stores=${selectedStore?.value}`
      );

      // Just update the count without switching tabs
      if (response.data.count !== newOrdersCount) {
        setDataCount(prev => ({
          ...prev,
          Placed: response.data.count
        }));
        setNewOrdersCount(response.data.count);
      }
    } catch (error) {
      console.error("Error checking new orders:", error);
    }
  };

  function showAddress() {
    // Use delivery_address & customer_details from order-detail API
    const deliveryAddress = OrderBiId[0]?.delivery_address;
    const customerDetails = OrderBiId[0]?.customer_details;
    setSelectedOrderForAddress({ deliveryAddress, customerDetails });
    setModalShow(true);
  }

  function HandleMiniPopUpClose() {
    setModalShow(false);
    setSelectedOrderForAddress(null);
  }

  // The rest of your JSX remains the same...
  // [Keep all your JSX code as it is, only the implementation details changed]

  return (
    <div>
      <div className="row">
        <div className="col-3 Manage-Orders">
          <h6>Manage Orders:</h6>
        </div>
        <div className="col-9 order-header-main">
          <div className="orders-inProgress">
            <div
              className={
                Active === "Placed" ? "activeCalss-order" : "Class-order"
              }
              onClick={() => Handlestatus("Placed")}
            >
              <div>New</div>
              <div
                className={
                  Active === "Placed" ? "length-data" : "lenght-Inactive"
                }
              >
                {DataCount.Placed ? DataCount.Placed : 0}
              </div>
            </div>
            <div
              className={
                Active === "Accepted" ? "activeCalss-order" : "Class-order"
              }
              onClick={() => Handlestatus("Accepted")}
            >
              <div>Accepted</div>
              <div
                className={
                  Active === "Accepted" ? "length-data" : "lenght-Inactive"
                }
              >
                {DataCount.Accepted ? DataCount.Accepted : 0}
              </div>
            </div>
            <div
              className={
                Active === "Ready to Ship" ? "activeCalss-order" : "Class-order"
              }
              onClick={() => Handlestatus("Ready to Ship")}
            >
              <div>Ready to Ship</div>
              <div
                className={
                  Active === "Ready to Ship" ? "length-data" : "lenght-Inactive"
                }
              >
                {DataCount["Ready to Ship"] ? DataCount["Ready to Ship"] : 0}
                {/* {DataCount.Accepted ? DataCount.Accepted : 0} */}
              </div>
            </div>
            <div
              className={
                Active === "Shipped" ? "activeCalss-order" : "Class-order"
              }
              onClick={() => Handlestatus("Shipped")}
            >
              <div>Shipped</div>
              <div
                className={
                  Active === "Shipped" ? "length-data" : "lenght-Inactive"
                }
              >
                {DataCount.Shipped ? DataCount.Shipped : 0}
              </div>
            </div>
            <div
              className={
                Active === "Delivered" ? "activeCalss-order" : "Class-order"
              }
              onClick={() => Handlestatus("Delivered")}
            >
              <div>Delivered</div>
              <div
                className={
                  Active === "Delivered" ? "length-data" : "lenght-Inactive"
                }
              >
                {DataCount.Delivered ? DataCount.Delivered : 0}
              </div>
            </div>
            <div
              className={
                Active === "Rejected" ? "activeCalss-order" : "Class-order"
              }
              onClick={() => Handlestatus("Rejected")}
            >
              <div>Rejected</div>
              <div
                className={
                  Active === "Rejected" ? "length-data" : "lenght-Inactive"
                }
              >
                {DataCount.Rejected ? DataCount.Rejected : 0}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row ">
        <div className=" col-3 input-with-icon zero-padding">
          <span className="icon">
            {" "}
            <TbSearch />
          </span>
          <input
            className="input-control"
            type="text"
            placeholder="Search With Order Id"
            onChange={HandleSearch}
          />
        </div>
        {user.role === "Admin" && (
          <div className="store-select col-9">
            <Select
              options={stores.map((store) => ({
                value: store.id,
                label: store.name,
              }))}
              placeholder="Select Store"
              value={stores
                .map((store) => ({ value: store.id, label: store.name }))
                .find((res) => res.value === parseFloat(selectedStore.value))}
              onChange={(selectedOption) => handleStoreChange(selectedOption)}
              isClearable
            />
          </div>
        )}
      </div>
      <div className="row">
        <div
          className="col-3 order-data"
          onScroll={(e) => handleInfiniteScroll(e)}
        >
          {loading ? (
            <div className="loader-container">
              <img
                src={require("../Components/FormParser/images/loader.gif")}
                alt="Loading..."
              />
            </div>
          ) : (
            OrderDetail.map((order, i) => {
              return (
                <div
                  className={
                    OrderId === i ? "ordrs-bottom active" : "ordrs-bottom"
                  }
                  key={i}
                  onClick={() =>
                    HandleOrder(
                      order.id,
                      i,
                      order.total_quantity,
                      order.orderstatus,
                      order.delivery_charges,
                      order.packing_charges,
                      order.discount_amount,
                      order.total_amount,
                      order.net_amount,
                      order.user_name,
                      order.addresses,
                      order.delivery_type,
                      order.store,
                      order.invoice,
                      order.payment_mode,
                      order
                    )
                  }
                >
                  <div className="d-flex justify-content-between ">
                    <div className="order_id">{order.order_id}</div>
                    <div className="order-time">
                      {order.order_date.split("T")[0]}
                    </div>
                  </div>
                  <div className="store-date">
                    <div className="store-name">
                      {order.store ? order.store.name : "add store -"}
                    </div>
                    <div>{timeConvert(order.order_date)}</div>
                  </div>
                  <div className="order-money-items">
                    <div className="f_12_400">{order.total_quantity} Items</div>
                    <div className="f_12_400">
                      <BiRupee />
                      {parseInt(order.net_amount)}
                    </div>
                  </div>
                </div>
              );
            })
          )}
          {loading2 && (
            <div className="loader-container">
              <img
                src={require("../Components/FormParser/images/loader.gif")}
                alt="Loading..."
              />
            </div>
          )}
        </div>
        {OrderBiId.length > 0 ? (
          <div className="col-9 order-act">
            <div className="row border-order">
              <div className="col-5 order-actions">{HandleButtons()}</div>
              <div className="col-4" style={{ borderRight: "1px solid #ddd" }}>
                <div className="store-details-roder">
                  <div className="f_14_500">Order Id</div>
                  <div className="w_130 ellipsis">{OrderBiId[0].order_id}</div>
                </div>
                <div className="store-details-roder">
                  <div className="f_14_500">Delivery Agent</div>
                  <div className="f_14_400 w_130 rowAligned">
                    <div className="ellipsis w_100">
                      {oreders.delivery_agent?.user?.full_name}
                    </div>
                  </div>
                </div>
                <div className="store-details-roder">
                  <div className="f_14_500">Store</div>
                  <div className="f_14_400 w_130 ellipsis">
                    {oreders.store?.name}
                  </div>
                </div>
                <div className="store-details-roder">
                  <div className="f_14_500">Delivery type</div>
                  <div className="f_14_400 w_130 ellipsis">
                    {oreders?.delivery_type}
                  </div>
                </div>
              </div>
              <div className="col-3">
                <div className="actions">
                  <div className="d-flex align-items-center justify-content-between">
                    <MdPrint
                      size={24}
                      onClick={() => handlePrint(oreders.order_id)}
                      style={{ cursor: "pointer" }}
                    />
                    {Active !== "Delivered" && Active !== "Rejected" && (
                      <>
                        <MdOutlineEditNote
                          size={24}
                          onClick={() => Handlebutttons("Modify")}
                          style={{ cursor: "pointer" }}
                        />
                        <IoCloseCircleOutline
                          color="red"
                          size={24}
                          onClick={() => Handlebutttons("Reject")}
                          style={{ cursor: "pointer" }}
                        />
                      </>
                    )}
                  </div>
                  <div className="rowBetweenCenter">
                    <div className="f_14_500">Expected date : </div>
                    <div className="f_14_400">
                      {oreders.order?.expected_date_time
                        ? oreders.order.expected_date_time.split("T")[0]
                        : OrderDetail.find((item) => item.id === oreders.order_id)?.expected_date_time?.split("T")[0]
                      }
                    </div>
                  </div>
                  {oreders?.delivery_type !== "Express" ? (
                    <div className="rowBetweenCenter">
                      <div className="f_14_500">Scheduled slot : </div>
                      <div className="f_14_400">
                        {oreders.order?.schedule_slot
                          ? oreders.order.schedule_slot
                          : OrderDetail.find((item) => item.id === oreders.order_id)?.schedule_slot
                        }
                      </div>
                    </div>
                  ) : (
                    <div className="rowBetweenCenter">
                      <div className="f_14_500">Expected time : </div>
                      <div className="f_14_400">
                        {oreders.order?.expected_date_time
                          ? oreders.order.expected_date_time.split("T")[1].split(":").slice(0, 2).join(":")
                          : OrderDetail.find((item) => item.id === oreders.order_id)?.expected_date_time?.split("T")[1]?.split(":").slice(0, 2).join(":")
                        }
                      </div>
                    </div>
                  )}
                  {loadingButton ? (
                    <div className="text-center">
                      <img
                        src={require("../Components/FormParser/images/loader.gif")}
                        alt="Loading..."
                        className="loader-image"
                      />
                    </div>
                  ) : (
                    <>
                      {oreders.status === "Placed" && (
                        <button
                          type="button"
                          className="btn btn-pink f_14_500"
                          onClick={() => Handlebutttons("Done")}
                        >
                          Accept Order
                        </button>
                      )}
                      {oreders.status === "Accepted" && (
                        <button
                          type="button"
                          className="btn btn-pink f_14_500"
                          onClick={() => Handlebutttons("Ready to Ship")}
                        >
                          Ready to Ship
                        </button>
                      )}
                      {oreders.status === "Ready to Ship" && (
                        <button
                          type="button"
                          className="btn btn-pink f_14_500"
                          onClick={() => Handlebutttons("Shipped")}
                        >
                          Ship Order
                        </button>
                      )}
                      {oreders.status === "Shipped" && (
                        <button
                          type="button"
                          className="btn btn-pink f_14_500"
                          onClick={() => {
                            Handlebutttons("Delivered");
                          }}
                        >
                          Deliver Order
                        </button>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
            {Active === "Shipped" ? (
              <div className="ordrs-tota-button">
                <button type="button" className="button-orders-image">
                  <GrGallery />{" "}
                  <span className="button-text-order">
                    Photos by QC & Partner
                  </span>
                </button>
              </div>
            ) : Active === "Delivered" ? (
              <div className="oreder-precessed">
                <div>
                  <img
                    className="success-image"
                    src={require("./images/tick.png")}
                    alt="tick"
                  />
                </div>
                <div>
                  <p>This order has been processed successfully</p>
                </div>
              </div>
            ) : Active === "Rejected" ? (
              <div className="oreder-precessed">
                <div>
                  <img
                    className="success-image"
                    src={require("./images/tick.png")}
                    alt="tick"
                  />
                </div>
                <div>
                  <p>This order has been Cancelled</p>
                </div>
              </div>
            ) : (
              <div className="ordrs-total rowBetweenCenter">
                <span>Total Items-{oreders.total_items}</span>
                <span>Payment mode : {oreders.payment_mode}</span>
              </div>
            )}
            <div className="table-responsive order-header">
              <DataTable
                columns={columns}
                data={OrderBiId}
                fixedHeader
                customStyles={tableCustomStyles}
                subHeader
                progressPending={loading}
                progressComponent={
                  <div className="loader-container">
                    <img
                      src={require("../Components/FormParser/images/loader2.gif")}
                      alt="Loading..."
                    />
                  </div>
                }
              />
            </div>
            <div className="money-data">
              <div>
                <div className="price-border">
                  <div className="details-money">
                    <div className="rowCenter">
                      <p>Item Total</p>
                      {/* {oreders.discount_amount > 0 && <p className="saved">saved {oreders.discount_amount}</p>} */}
                      {oreders.discount_amount > 0 && (
                        <p className="saved">
                          saved ₹
                          {
                            parseFloat(oreders.discount_amount).toFixed(2)
                            // parseFloat(discountTotals?.bogo_discount) +
                            // parseFloat(discountTotals?.product_discount).toFixed(2)
                          }
                        </p>
                      )}
                    </div>
                    {oreders.discount_amount > 0 ? (
                      <div className="rowCenter gap-10">
                        <p>
                          <strike>
                            {/* {parseFloat(oreders.total_amount) +
                              parseFloat(oreders.discount_amount).toFixed(2)} */}
                            {(parseFloat(oreders.total_amount) + parseFloat(oreders.discount_amount)).toFixed(2)}
                          </strike>
                        </p>
                        <p>{parseFloat(oreders.total_amount).toFixed(2)}</p>
                      </div>
                    ) : (
                      <p>{oreders.total_amount}</p>
                    )}
                  </div>
                  <div className="details-money">
                    <p>Delivery Charges</p>
                    {oreders.delivery_charges !== "0.00" ? (
                      <p>{oreders.delivery_charges}</p>
                    ) : (
                      <>
                        {oreders.order.coupon_code?.length > 0 &&
                          oreders.order.coupon_code[0].discount_type ===
                          "FreeDeliveryChargesCoupon" ? (
                          <></>
                        ) : (
                          <strike>{oreders.delivery_charges_offer}</strike>
                        )}
                        <span>
                          {oreders.order.coupon_code?.length > 0 &&
                            oreders.order.coupon_code[0].discount_type ===
                            "FreeDeliveryChargesCoupon"
                            ? "Free Delivery"
                            : parseFloat(oreders.net_amount) >= 5000
                              ? "waiver"
                              : ""}
                        </span>
                      </>
                    )}
                  </div>

                  <div className="details-money">
                    <p>Packing Charges</p>
                    {oreders.packing_charges !== "0.00" ? (
                      <p>{oreders.packing_charges}</p>
                    ) : (
                      <>
                        <strike>{oreders.packing_charges_offer}</strike>
                        <span>
                          {parseFloat(oreders.net_amount) >= 5000 ? "Waiver" : ""}
                        </span>
                      </>
                    )}
                  </div>

                  {/* <div className="details-money">
                  <p>Discount</p>
                  <p>{oreders.discount_amount}</p>
                </div> */}
                  {discountTotals?.bogo_discount > 0 && (
                    <div className="rowBetweenCenter">
                      <p>Buy 1 Get 1 discount</p>
                      <p>-₹{parseFloat(discountTotals.bogo_discount)}</p>
                    </div>
                  )}
                  {discountTotals?.product_discount > 0 && (
                    <div className="rowBetweenCenter">
                      <p>Coupon discount</p>
                      <p>
                        -₹
                        {parseFloat(discountTotals.product_discount).toFixed(2)}
                      </p>
                    </div>
                  )}
                </div>

                <div className="details-money-total">
                  <p>Grand Total</p>
                  <p>{parseFloat(oreders.net_amount).toFixed(2)}</p>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="col-9 text-center">
            <div className="no-orders"></div>
            <p className="para-table-nodata">No {Active} Orders</p>
          </div>
        )}
        {popupType !== "" && (
          <PopupModal
            popupType={popupType}
            setpopupType={setpopupType}
            Message={message}
            OrderDetails={OrderDetails}
            Active={Active}
          />
        )}
        {AlertDeletePopupType === "success" && (
          <AlertDeletePopupModal
            AlertDeletePopupType={AlertDeletePopupType}
            HandleDelete={HandleDelete}
            CancelAlerrt={CancelAlerrt}
            row={RowId}
            Message={message}
          />
        )}
        {AlertDeletePopupType1 === "success" && (
          <AlertDeletePopupModal
            AlertDeletePopupType={AlertDeletePopupType1}
            HandleDelete={HandleAccept}
            CancelAlerrt={CancelAlerrt1}
            row={RowId1}
            Message={message}
          />
        )}
      </div>
      <Modal
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered

        onHide={HandleMiniPopUpClose}
        show={modalShow}
      >
        <Modal.Body className="modal-body-viewCart">
          {selectedOrderForAddress && selectedOrderForAddress.deliveryAddress ? (
            <div className="address-details">
              <div className="rowAligned gap-10 mb-2">
                <MdOutlineMapsHomeWork size={16} />
                <div className=" f_13_600">
                  {selectedOrderForAddress.customerDetails?.full_name || selectedOrderForAddress.deliveryAddress.name}
                </div>
              </div>
              <div className="rowAligned gap-10 mb-2">
                <MdOutlineLocationOn size={16} />
                <div className="c f_13_500">
                  {selectedOrderForAddress.deliveryAddress.address}
                </div>
              </div>
              <div className="rowAligned gap-10 mb-2">
                <MdOutlineLocalPhone size={16} color="#8C8C8C" />
                <div style={{ color: "#8C8C8C" }}>
                  {selectedOrderForAddress.customerDetails?.mobileno || selectedOrderForAddress.deliveryAddress?.user?.mobileno}
                </div>
              </div>
              {selectedOrderForAddress.deliveryAddress.latitude && selectedOrderForAddress.deliveryAddress.longitude && (
                <div className="rowAligned gap-10 mb-2">
                  <SiGooglemaps size={16} color="#8C8C8C" />
                  <div style={{ color: "#8C8C8C" }}>
                    <a target="_blank" href={`https://www.google.com/maps?q=${selectedOrderForAddress.deliveryAddress.latitude},${selectedOrderForAddress.deliveryAddress.longitude}`}>{`https://www.google.com/maps?q=${selectedOrderForAddress.deliveryAddress.latitude},${selectedOrderForAddress.deliveryAddress.longitude}`}</a>
                    <span className="ms-1"><IoMdCopy style={{ cursor: "pointer" }} size={23} color="#8C8C8C" onClick={() => {
                      const url = `https://www.google.com/maps?q=${selectedOrderForAddress.deliveryAddress.latitude},${selectedOrderForAddress.deliveryAddress.longitude}`;
                      navigator.clipboard.writeText(url);
                      alert("copied")
                    }} />
                    </span>
                  </div>
                </div>
              )}
              {selectedOrderForAddress.deliveryAddress.landmark && (
                <div className="rowAligned gap-10">
                  <MdOutlineLocationOn size={16} color="#8C8C8C" />
                  <div style={{ color: "#8C8C8C" }}>
                    Landmark: {selectedOrderForAddress.deliveryAddress.landmark}
                  </div>
                </div>
              )}
            </div>
          ) : (
            <div>No address information available</div>
          )}
        </Modal.Body>
      </Modal>
      <Modal
        show={show}
        onHide={() => {
          setShow(false);
          setLoadingButton(false);
        }}
        aria-labelledby="example-modal-sizes-title-sm"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-sm">
            <div>Ship order via</div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ShippingInstructions
            show={show}
            setShow={setShow}
            orderId={oreders?.order_id}
            setLoadingButton={setLoadingButton}
            setActive={setActive}
            CountDisplay={CountDisplay}
            OderSCount={OderSCount}
            onOrderAccepted={() => {
              // Refresh the order data after acceptance
              OrderDetails("Accepted");
              Handlestatus("Accepted"); // This will switch to the Accepted tab
            }}
          />
        </Modal.Body>
      </Modal>
    </div>
  );
};
export { Orders };